import React from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import Button from 'components/Button'
import T from 'components/FormattedMessage'
import UserPhotoWithUpload from 'components/UserPhotoWithUpload'

import { Dialog, DialogContent, DialogActions } from '@material-ui/core'
import { cropImage, createImageElementFromFile } from 'lib/images'

interface Props {
  onPhotoUploadFail?: (err: ErrorEvent) => any // tslint:disable-line:no-any
  onPhotoAccept: (data: Blob, url: string) => any // tslint:disable-line:no-any
  showUploadIcon: boolean
  photoUrl: string
}

type State = {
  uploadedImage?: HTMLImageElement
  cropState: ReactCrop.Crop
}

const initialCropState = { width: 50, aspect: 1 }

class UserPhotoWithUploadAndCropper extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      uploadedImage: undefined,
      cropState: initialCropState as ReactCrop.Crop,
    }
  }

  private onPhotoUpload = async (file: File) => {
    try {
      const image = await createImageElementFromFile(file)

      this.setState({ uploadedImage: image })
    } catch (err) {
      if (this.props.onPhotoUploadFail) {
        this.props.onPhotoUploadFail(err)
      }
    }
  }

  private updateCropState = (cropState: ReactCrop.Crop) => {
    this.setState({ cropState })
  }

  private selectImage = async () => {
    const blob = await cropImage(this.state.uploadedImage!, this.state.cropState, 300)

    this.setState({ uploadedImage: undefined, cropState: initialCropState as ReactCrop.Crop })
    this.props.onPhotoAccept(blob, URL.createObjectURL(blob)) // TODO: memory leak
  }

  private renderImageCropper() {
    const { width, height } = this.state.cropState
    const shouldAcceptButtonVisible = width! > 0 && height! > 0
    const { uploadedImage } = this.state

    return (
      <Dialog open={uploadedImage !== undefined}>
        <DialogContent>
          {uploadedImage !== undefined && (
            <ReactCrop
              src={uploadedImage.src}
              crop={this.state.cropState}
              onChange={this.updateCropState}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            disabled={!shouldAcceptButtonVisible}
            onClick={this.selectImage}
          >
            <T id="web_account_action_acceptphoto" />
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  render() {
    return (
      <div>
        {this.renderImageCropper()}
        <UserPhotoWithUpload
          photoUrl={this.props.photoUrl}
          onPhotoUpload={this.onPhotoUpload}
          showUploadIcon={this.props.showUploadIcon}
        />
      </div>
    )
  }
}

export default UserPhotoWithUploadAndCropper
